module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4edd383da41c26587d94ac5fdfbc3450.png";